import React from 'react'
import { ArrowLeftIcon } from 'lucide-react'
import { mobile } from './tokens'

interface MobilePageHeaderProps {
  title: string
  subtitle?: React.ReactNode
  /** Optional back action — shows a 44px hit target */
  onBack?: () => void
  backLabel?: string
  actions?: React.ReactNode
  sticky?: boolean
  className?: string
}

export function MobilePageHeader({
  title,
  subtitle,
  onBack,
  backLabel = 'Back',
  actions,
  sticky = false,
  className = '',
}: MobilePageHeaderProps) {
  const body = (
    <div className={`flex items-start justify-between gap-3 ${className}`.trim()}>
      <div className="flex items-start gap-1 min-w-0 flex-1">
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            className={`${mobile.ghostBtn} -ml-2 flex-shrink-0 mt-0.5`}
            aria-label={backLabel}
          >
            <ArrowLeftIcon className="w-5 h-5" />
          </button>
        )}
        <div className="min-w-0">
          <h1 className={mobile.title}>{title}</h1>
          {subtitle != null && subtitle !== '' && (
            <div className={mobile.subtitle}>{subtitle}</div>
          )}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
    </div>
  )

  if (sticky) {
    return <div className={mobile.stickyHeader}>{body}</div>
  }
  return body
}
